export const RoleTypes = {
  CONTRIBUTOR_TO_CONSUMER: 'CONTRIBUTOR_TO_CONSUMER', // Contributing Directly to Consumer
  PROVIDER_ON_BEHALF_OF: 'POB', // Provider On Behalf Of Contributor
  PROVIDER_ON_BEHALF_OF_PRINCIPALS: 'POBOP', // Provider On Behalf Of Principals
  CONTRIBUTOR_OR_PROVIDER_TO_AGENT: 'CONTRIBUTOR_OR_PROVIDER_TO_AGENT' // Contributing to Agent who is Receving On Behalf Of his Principals
}

export const CombinedFlows = {
  CONTRIBUTOR_ONLY: 'CONTRIBUTOR_ONLY',                 
  POB_ONLY: 'POB_ONLY',          
  POBOP_ONLY: 'POBOP_ONLY',                      
  CONTRIBUTOR_POB: 'CONTRIBUTOR_POB',           
  POB_POBOP: 'POB_POBOP',            
  CONTRIBUTOR_POBOP: 'CONTRIBUTOR_POBOP',           
  CONTRIBUTOR_POB_POBOP: 'CONTRIBUTOR_POB_POBOP',      
}

export const RecipientTypes = {
  AGENT: 'AGENT',
  NON_AGENT: 'NON_AGENT',
  MY_PITSTOP: 'MY_PITSTOP',
}

export const TransactionTypes = {
  PUSH_STORE: 'PUSH_STORE',
  PUSH_TO_AGENT: 'PUSH_TO_AGENT',
}
